import React, { useEffect, useState, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// import DarkModeBtn from '../components/DarkModeBtn';
import { useUser } from '../contexts/UserContext';
import LogoutButton from '../components/LogoutButton';
// Importamos los nuevos componentes
import DashboardNotValidated from '../components/Dashboard/DashboardNotValidated';
import DashboardValidated from '../components/Dashboard/DashboardValidated';
import UserActionsBar from '../components/UserActionsBar';
function Dashboard() {
   const initialValidationCheck = useRef(false);
   // Eliminamos userData de la desestructuración para evitar la advertencia
   // const { userEmail, userName, isLoading, isAuthenticated } = useUser();
   const { isLoading, isAuthenticated } = useUser();
   const navigate = useNavigate();
   const [kycCompleted, setKycCompleted] = useState(false);
   const [kycValidated, setKycValidated] = useState('loading'); // Puede ser 'loading', true, o false
   const [balances, setBalances] = useState({
      USD: 0,
      USDC: 0,
      USDT: 0,
      BTC: 0,
      ETH: 0,
      POL: 0,
      PROPT: 0
   });
   // Verificar estado de KYC
   const fetchKycStatus = async () => {
      const jwt = localStorage.getItem('jwt');
      const res = await fetch('https://pt-api.digit-a.net/api/steps/get-steps-status', {
         headers: {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json'
         }
      });
      const data = await res.json();
      setKycCompleted(!!data.isCompleted);
   };
   // Obtener el estado de validación de KYC
   const fetchKycValidated = async () => {
      try {
         const jwt = localStorage.getItem('jwt');
         const email = localStorage.getItem('userEmail');
         if (!jwt || !email) {
            setKycValidated(false);
            return
         };
         // Control de frecuencia más robusto
         if (!fetchKycValidated.lastCallTime) {
            fetchKycValidated.lastCallTime = 0;
         }
         const now = Date.now();
         if (now - fetchKycValidated.lastCallTime < 5000) {
            console.log("Omitiendo llamada a get-user-by-email (demasiado frecuente)");
            return;
         }
         fetchKycValidated.lastCallTime = now;
         const res = await fetch('https://pt-api.digit-a.net/api/users/get-user-by-email', {
            method: 'POST',
            headers: {
               'Authorization': `Bearer ${jwt}`,
               'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email })
         });
         const data = await res.json();
         if (data && data.user) {
            const isValidated = !!data.user.kycValidated;
            setKycValidated(isValidated);
            // Si está validado, cancelamos el intervalo para evitar más llamadas
            if (isValidated && window.kycCheckInterval) {
               console.log("KYC validado. Deteniendo verificaciones periódicas.");
               clearInterval(window.kycCheckInterval);
               window.kycCheckInterval = null;
            }
            // Si tenemos datos de wallets, actualizamos los balances
            if (data.user.wallets && Array.isArray(data.user.wallets)) {
               const balancesData = {};
               data.user.wallets.forEach(wallet => {
                  balancesData[wallet.currency] = wallet.balance || 0;
               });
               setBalances(prev => ({ ...prev, ...balancesData }));
            }
         } else {
            setKycValidated(false);
         }
      } catch (error) {
         console.error("Error fetching KYC validation status:", error);
         setKycValidated(false);
      }
   };
   // Verificar autenticación
   useEffect(() => {
      if (!isAuthenticated && !isLoading) {
         navigate('/sign-in');
      }
   }, [isAuthenticated, isLoading, navigate]);

   useEffect(() => {
      localStorage.removeItem('mnemonicPhrase');
   }, []);

   useEffect(() => {
      // Solo ejecuta la lógica si el usuario está autenticado
      if (isAuthenticated) {
         // Llama a las funciones para obtener los datos la primera vez
         fetchKycStatus();
         fetchKycValidated();

         // Configura un intervalo para re-verificar solo si es necesario
         const intervalId = setInterval(() => {
            // Usamos una función callback para leer el estado más reciente de kycValidated
            setKycValidated(currentStatus => {
               // Si ya se validó (es true), no hacemos más llamadas y limpiamos el intervalo
               if (currentStatus === true) {
                  clearInterval(intervalId);
                  return true;
               }
               // Si no, significa que sigue siendo 'loading' o 'false', así que volvemos a verificar
               fetchKycStatus();
               fetchKycValidated();
               return currentStatus;
            });
         }, 60000); // Re-verifica cada 60 segundos

         // Función de limpieza para cuando el componente se desmonte
         return () => clearInterval(intervalId);
      }
   }, [isAuthenticated]); // La clave: Solo depende de isAuthenticated


   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (!isAuthenticated) {
      return null;
   }

   // cargando
   if (kycValidated === 'loading') {
      return (
         <div className="container-fluid max py-lg-5 placeholder-glow" aria-hidden="true">
            {/* Esqueleto de la cabecera (Navbar ya está visible, no es necesario) */}
            <nav className="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            </nav>

            {/* Esqueleto del contenido principal */}
            <div className="row mb-5">
               <div className="col-12 col-lg-auto pt-5 mb-4 mb-lg-0">
                  {/* Esqueleto para la barra lateral de balance */}
                  <div className="ppt_box_gen sidebar h-100 d-flex flex-column align-items-center">
                     <span className="placeholder col-6 mb-2"></span>
                     <span className="placeholder col-8 fs-1 mb-4"></span>
                     <div className="placeholder" style={{ width: '215px', height: '215px', borderRadius: '50%' }}></div>
                  </div>
               </div>
               <div className="col">
                  <div className="row mb-5 mx-auto max">
                     <div className="col px-0 px-lg-3">
                        <h3 className="ppt_form_title mb-3 placeholder col-4"></h3>
                        {/* Esqueleto para la caja de USD */}
                        <div className="ppt_box_gen placeholder" style={{ height: '120px' }}></div>
                     </div>
                  </div>
                  <div className="row mx-auto max">
                     <div className="col-12 px-0 px-lg-3">
                        <h3 className="ppt_form_title mb-3 placeholder col-5"></h3>
                     </div>
                     {/* Esqueleto para las cajas de crypto */}
                     <div className="col-12 col-lg-6 mb-4 px-0 px-lg-3">
                        <div className="ppt_box_gen placeholder" style={{ height: '120px' }}></div>
                     </div>
                     <div className="col-12 col-lg-6 mb-4 px-0 px-lg-3">
                        <div className="ppt_box_gen placeholder" style={{ height: '120px' }}></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      )
   }

   return (
      <div className="container-fluid max py-lg-5" page-key="Dashboard">
         {/* Cabecera común para ambas vistas */}
         <nav className="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div className="container-fluid px-0">
               <div className="row align-items-center w-100 mx-0" data-orders>
                  <div data-order="1" className="col col-lg-3 px-0">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div data-order="2" className="col-auto d-flex align-items-center gap-3 px-0">
                     <UserActionsBar />
                     <span className="d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <svg width="28" height="23" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <rect x="0.577148" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="9.73077" width="27.4231" height="3.53846" fill="var(--white)" />
                           <rect x="0.577148" y="19.4615" width="27.4231" height="3.53846" fill="var(--white)" />
                        </svg>
                     </span>
                  </div>
                  <div data-order="3" className="collapse navbar-collapse" id="navbarNavDropdown">
                     <div className="col">
                        <nav className="ppt_navdash">
                           <NavLink to="/dashboard" className="link">Wallet</NavLink>
                           <NavLink to="/propt-tokens" className="link">Propt Tokens</NavLink>
                           {/* <span className="link">Earn</span> */}
                           <NavLink to="/support" className="link">SUPPORT</NavLink>
                           <NavLink to="/settings" className="link d-lg-none">SETTINGS</NavLink>
                           <span className="link d-lg-none">
                              <LogoutButton />
                           </span>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
         </nav>

         <span className="nonavbar d-lg-none">
            <UserActionsBar />
         </span>

         {/* Renderizado condicional usando los componentes importados */}
         {kycValidated ?
            <DashboardValidated balances={balances} /> :
            <DashboardNotValidated balances={balances} kycCompleted={kycCompleted} />
         }
      </div>
   );
}
export default Dashboard;